module.exports = function() {
  return new Worker(__webpack_public_path__ + "23454120a81ec95b826d.worker.js");
};